import React, {useMemo, useState} from 'react';
import {Button, Stack, Figure, ListGroup, Alert,} from "react-bootstrap";
import {Link, useNavigate, useParams} from "react-router-dom";
import {ButtonDelete} from "../../../_components/DeleteButton";
import {useAlert, useAuth} from "../../../../context";
import {FileUpload, OurAlert, OurClearAlert, PageTitle, SingleText, ToggleText} from "../../../_components";
import {isoTimestampToReadableDate} from "../utilities/readableDate";
import {config} from "../../../../utils2";
import {getHumanReadableBytes} from "../utilities/convertBytes";
import {useInfiniteScroll, useMedia, useTagCount, useTagList, useTruncatedText} from "../../../../hooks";
import {DynamicBox, DynamicDialog} from "../../../_components/BoxGroupLayout";
import {Formik, Form as FormikForm, useFormikContext, FieldArray} from "formik";
import {WhiteCard} from "../../../device/_components/WhiteCard";


export function AddEditMedia() {
    const {mid} = useParams()
    const {userId} = useAuth()
    const {success} = useAlert()
    const navigate = useNavigate()

    const {
        value,
        validationSchema,
        addItem,
        editItem,
        deleteItem,
        errorValue,
        clearErrorValue,
    } = useMedia(userId, mid)

    const edit = mid !== "add"

    function handleSubmit(values, actions) {
        if (edit) {
            editItem(values)
                .then(msg => {
                    success(msg)
                    navigate(-1)
                })
                .catch(console.warn)
                .finally(() => actions.setSubmitting(false))
        } else {
            addItem(values)
                .then(msg => {
                    success(msg)
                    navigate(-1)
                })
                .catch(console.warn)
                .finally(() => actions.setSubmitting(false))
        }
    }


    function handleOnDelete() {
        deleteItem()
            .then(msg => {
                success(msg)
                navigate(-1)
            })
            .catch(console.warn)
    }

    const imageSize = [
        {id: true, name: "square", variant: "danger", disabled: false , icon: "bi bi-1-square"},
        {id: false, name: "rectangle", variant: "success", disabled: false, icon: "bi bi-aspect-ratio"},
    ]

    const isSquare = value.file_aspect_ratio === 1

    return (
        <>
            <OurClearAlert variant="danger" msg={errorValue} onClear={clearErrorValue}/>

            <PageTitle title="Media Details">{edit ? "Edit" : "Add"} media.</PageTitle>

            {/*<FieldInputs value={value} invalidValue={invalidValue} updateFields={setValue} edit={edit}></FieldInputs>*/}
            <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={{...value, square: edit ? isSquare : true}} enableReinitialize={true}>
                {({isSubmitting, resetForm}) => (
                    <FormikForm>

                        <RenderFigures edit={edit}/>

                        <WhiteCard>
                            <div className="d-flex flex-wrap gap-2">
                                {/*<FileUpload name="upload_white" label="File" className="flex-grow-1 my-2"/>*/}
                                <FileUpload name="upload_media" label="File" className="flex-grow-1 my-2"/>
                                <ToggleText name="square" label="Aspect ratio" items={imageSize}/>
                                {/*<FileUpload name="upload_black" label="File (black background)" className="flex-grow-1"/>*/}
                            </div>

                            <SingleText name="description" label="Description" maxLength="128" className="my-2 flex-grow-1"/>

                        </WhiteCard>

                        <WhiteCard>
                            <FieldArray name="tags" component={LinkedTags}/>
                        </WhiteCard>

                        <Stack className="my-2 text-secondary">
                            {value.created_at && <span>Created at: {isoTimestampToReadableDate(value.created_at)}</span>}
                            {value.updated_at && <span>Updated at: {isoTimestampToReadableDate(value.updated_at)}</span>}
                        </Stack>

                        <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                            <Button as={Link} variant="link" to={-1}>Go back</Button>
                            <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                            {edit && <ButtonDelete variant="danger" onDelete={handleOnDelete} value={value.name}>Delete</ButtonDelete>}
                            <Button type="submit" variant="success" disabled={isSubmitting}>Save</Button>
                        </Stack>

                    </FormikForm>
                )}
            </Formik>
        </>
    );
}

function RenderFigures({edit}) {
    const {values} = useFormikContext()

    const media_white = values?.upload_media
    // const media_black = values?.upload_black

    const media_src_white = media_white ? URL.createObjectURL(media_white) : config.get_public_media(values.path, "medium", false, true)
    // const media_src_black = media_black ? URL.createObjectURL(media_black) : config.get_public_media(values.path, "thumb", "black", true)

    const desc_white = values?.description || "Picture with white background"
    // const desc_black = values?.description || "Picture with black background"

    return <>
        <RenderFigure edit={edit} media_src={media_src_white} size={values?.file_size} aspectRatio={values?.file_aspect_ratio} description={desc_white}
                      hrefT={config.get_public_media(values.path, "thumb")}
                      hrefM={config.get_public_media(values.path, "medium")}
                      hrefB={config.get_public_media(values.path, "big")}
        />
        {/*<RenderFigure edit={edit} media_src={media_src_white} size={values?.file_size_white} description={desc_white}*/}
        {/*              href={config.get_public_media(values.path, "big", "white")}/>*/}
        {/*<RenderFigure edit={edit} media_src={media_src_black} size={values?.file_size_black} description={desc_black}*/}
        {/*              href={config.get_public_media(values.path, "big", "black")}/>*/}
    </>
}

function RenderFigure({edit, media_src, size,aspectRatio, description, hrefT, hrefM, hrefB}) {
    const [showFigErr, setShowFigErr] = useState(false)

    const [copied, setCopied] = useState({});

    // function handleCopy(path) {
    //     navigator.clipboard.writeText(path)
    //         .then(() => {
    //             setCopied(true);
    //             setTimeout(() => {
    //                 setCopied(false);
    //             }, 2000); // hide after 2 seconds
    //         })
    //         .catch((err) => {
    //             console.error('Failed to copy: ', err);
    //         });
    // }

    // function handleCopy(path) {
    //     navigator.clipboard.writeText(path).then(() => {
    //         alert('Copied to clipboard!');
    //     }).catch((err) => {
    //         console.error('Failed to copy: ', err);
    //     });
    // }

    function handleCopy(path, key) {
        navigator.clipboard.writeText(path)
            .then(() => {
                setCopied(prev => ({ ...prev, [key]: true }));
                setTimeout(() => {
                    setCopied(prev => ({ ...prev, [key]: false }));
                }, 3000);
            })
            .catch((err) => {
                console.error('Failed to copy: ', err);
            });
    }


    function decimalToFraction(decimal) {
        if (Number.isInteger(decimal)) return `${decimal}/1`;

        const tolerance = 1.0E-8;
        let h1 = 1, h2 = 0;
        let k1 = 0, k2 = 1;
        let b = decimal;
        do {
            const a = Math.floor(b);
            let aux = h1;
            h1 = a * h1 + h2;
            h2 = aux;
            aux = k1;
            k1 = a * k1 + k2;
            k2 = aux;
            b = 1 / (b - a);
        } while (Math.abs(decimal - h1 / k1) > decimal * tolerance);

        return `${h1}/${k1}`;
    }
    return <>
        <OurAlert variant="danger" show={showFigErr} title="Image not found!">
            <Alert.Link href={media_src} target="_blank" rel="noopener noreferrer">{media_src}!</Alert.Link>
        </OurAlert>

        {(!showFigErr && media_src) &&
            <div className="d-flex justify-content-center">
                <Figure className="text-center">
                    <Figure.Image
                        src={media_src}
                        alt={description}
                        // width="150px"
                        // height="200px"
                        onError={() => setShowFigErr(true)}
                    />
                    {edit && <Figure.Caption>
                        <div className="d-flex flex-column align-items-center gap-2">
                            <div className="d-flex align-items-center gap-2">
                                <div>Thumb: <a href={hrefT} target="_blank" rel="noopener noreferrer">{hrefT}</a></div>
                                <Button size="sm" variant={copied.t ? "success":"outline-primary"} onClick={() => handleCopy(hrefT, "t")}><i className={copied ?"bi bi-clipboard-check" :"bi bi-copy"}/></Button>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <div>Medium: <a href={hrefM} target="_blank" rel="noopener noreferrer">{hrefM}</a></div>
                                <Button size="sm" variant={copied.m ? "success":"outline-primary"} onClick={() => handleCopy(hrefM, "m")}><i className={copied ?"bi bi-clipboard-check" :"bi bi-copy"}/></Button>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <div>Big: <a href={hrefB} target="_blank" rel="noopener noreferrer">{hrefB}</a></div>
                                <Button size="sm" variant={copied.b ? "success":"outline-primary"} onClick={() => handleCopy(hrefB, "b")}><i className={copied ?"bi bi-clipboard-check" :"bi bi-copy"}/></Button>
                            </div>
                            <span>File size: {getHumanReadableBytes(size)} (Medium)</span>
                            <span>Aspect ratio: {decimalToFraction(aspectRatio)}</span>
                        </div>
                    </Figure.Caption>}
                </Figure>
            </div>
        }
    </>
}


function LinkedTags({push, remove, form}) {
    const [show, setShow] = useState(false)
    const [filter, setFilter] = useState("")
    const [pageIndex, setPageIndex] = useState(0)

    const pageSize = 10

    const {count} = useTagCount()
    const {list, loadingList} = useTagList(pageSize, pageIndex, null, "name_asc", true)
    const lastElementRef = useInfiniteScroll(loadingList, list.length, count, pageSize, setPageIndex)

    const tempList = useMemo(() => list.filter(item => !form.values.tags.find(item2 => item2.id === item.id)), [list, form.values.tags])
    const renderList = useMemo(() => tempList.filter(item => item.name.toLowerCase().includes(filter.toLowerCase())), [filter, tempList])
    const selectedItems = useMemo(() => form.values.tags.sort((a, b) => a.name.localeCompare(b.name)), [form.values.tags])

    const isInvalid = typeof form.errors.tags === "string"


    return (
        <>
            <DynamicBox label="Link tags" isInvalid={isInvalid} feedback={form.errors.tags} button="Tag"
                        onClick={() => setShow(true)}>
                {selectedItems.map((item, index) => (
                    <Button key={index} className="mb-2" onClick={() => remove(index)} variant={item.variant}>{item.name} <i
                        className="bi bi-x-lg"/></Button>
                ))}
            </DynamicBox>
            <DynamicDialog title="Select Tag" show={show} onHide={() => setShow(false)} filter={filter} setFilter={setFilter}>
                <div>Loaded {list.length - selectedItems.length} of {count - selectedItems.length}</div>
                {renderList && renderList.length > 0 ?
                    renderList.map((item, index) => (
                        <ListGroup.Item key={item.id} eventKey={item.id} ref={renderList.length === index + 1 ? lastElementRef : null}>
                            <Button variant={item.variant} onClick={() => push(list.find(c => c.id === item.id))} className="mb-2">{item.name}</Button>
                        </ListGroup.Item>
                    ))
                    :
                    <span className="text-center">No tag found</span>
                }
            </DynamicDialog>
        </>
    )
}

